import { ListIndomixTypes } from '@constants/ral';
import { CollectionsRus } from '@enum/enum';
import useCustomNotify from '@hooks/useNotify';
import {
    EditProps,
    Edit,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    number,
    NumberInput,
    Toolbar,
    SaveButton,
    minValue
} from 'react-admin';
import { CopyFromRal } from './copyFromRal';
import RalComponents from './ralComponents';
import { useStyles } from './ralStyles';
import { validator } from './validator';

const ToolbarRal = (props: any) => (
    <Toolbar>
        <SaveButton {...props} mutationOptions="" />
    </Toolbar>
);

const RALEdit = (props: EditProps) => {
    const classes = useStyles();

    const {
        onSuccess,
        onFailure,
    } = useCustomNotify(CollectionsRus.RAL, 'edit', 'update');

    return (
        <Edit
            onSuccess={onSuccess}
            onFailure={onFailure}
            mutationMode="pessimistic"
            {...props}
        >
            <SimpleForm
                toolbar={<ToolbarRal />}
                validate={validator}
            >
                <CopyFromRal />

                <TextInput
                    label="Название"
                    source="name"
                    validate={[
                        required()
                    ]}
                />
    
                <TextInput
                    label="Код"
                    source="code"
                    validate={[
                        required(),
                        number()
                    ]}
                />

                <NumberInput
                    label="В 10-ти литрах - (...) кг"
                    source="koefWeightIn10L"
                    step={0.001}
                    validate={[
                        required(),
                        number(),
                        minValue(0.001)
                    ]}
                    onWheel={(e) => (e.target as any).blur()}
                    className={classes.newLines}
                />
    
                <SelectInput
                    source='category'
                    label="Категория"
                    choices={ListIndomixTypes}
                    validate={required()}
                />
    
                <RalComponents mode='input' />
            </SimpleForm>
        </Edit>
    );
};

export default RALEdit;
